import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Prop, Ref, SimpleEvent } from "@eastsideco/salvo-ts";
import Player from '@vimeo/player';
import YT from 'youtube-player';
import { YouTubePlayer } from "youtube-player/dist/types";

/**
 * ----------------------------------------------------------------------------
 * Component: Featured Video
 * - Creates featured video element for used with YouTube, Vimeo & Hosted videos.
 * - Video settings will be set within section settings.
 *
 * Section Example
 * {! component 'FeaturedVideo' with section: section !}
 * ------------------------------------------------------------------------------
 */
@Component
export class FeaturedVideo extends ThemeComponent  {

    /**
     * Initialise.
     */
    init() { }

}
